import { enhancedApi } from '@store/generated/jotdocs';

/**
 * Feature-specific tag types for jotdocs
 */
const JOTDOCS_TAG_TYPES = ['JotDoc'] as const;

/**
 * JotDocs API - extends the generated API with custom tagging
 */
export const jotdocsApi = enhancedApi.enhanceEndpoints({
  addTagTypes: JOTDOCS_TAG_TYPES,
  endpoints: {
    // Detail endpoint - provides tags for cache management
    getV2ProviderJotdocsByJotdocId: {
      providesTags: (_result, _error, arg) => [{ type: 'JotDoc' as const, id: arg.jotdocId }],
    },
    // Mutation endpoint - invalidates cache on update
    patchV2ProviderJotdocsByJotdocId: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'JotDoc' as const, id: arg.jotdocId }],
      onQueryStarted: async ({ jotdocId, updateJotDocRequest }, { dispatch, queryFulfilled }) => {
        // Optimistic update - mutate cache immediately if content is being updated
        if (updateJotDocRequest?.updated_fields?.content !== undefined) {
          const patchResult = dispatch(
            jotdocsApi.util.updateQueryData('getV2ProviderJotdocsByJotdocId', { jotdocId }, draft => {
              if (draft.jotdoc) {
                draft.jotdoc.content = updateJotDocRequest.updated_fields.content;
              }
            }),
          );

          try {
            await queryFulfilled;
            // On success, keep optimistic update (response will have same content)
          } catch {
            // Rollback optimistic update on error
            patchResult.undo();
          }
        }
      },
    },
  },
});

// Export hooks with user-friendly names
export const {
  useGetV2ProviderJotdocsByJotdocIdQuery: useGetJotDocQuery,
  useLazyGetV2ProviderJotdocsByJotdocIdQuery: useLazyGetJotDocQuery,
  usePatchV2ProviderJotdocsByJotdocIdMutation: useUpdateJotDocMutation,
} = jotdocsApi;

